import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ConfirmationModal from './ConfirmationModal'
import ConfirmedMessageModal from './ConfirmedMessage'
import ChangePasswordModal from './ChangePasswordModal'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const AccountSettingsModal = ({
  handleAccountSettingsModal,
  accountSettingsModal = false,
}) => {
  const [confirmationModal, setConfirmationModal] = React.useState(false)
  const [changePasswordModal, setChangePasswordModal] = React.useState(false)

  const handleConfirmationModal = () => {
    if (accountSettingsModal) {
      handleAccountSettingsModal(false)
    }
    setConfirmationModal(!confirmationModal)
  }

  const handleChangePasswordModal = () => {
    if (accountSettingsModal) {
      handleAccountSettingsModal(false)
    }
    setChangePasswordModal(!changePasswordModal)
  }

  return (
    <div>
      <Modal
        open={accountSettingsModal}
        onClose={() => handleAccountSettingsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="account-settings-modal">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Account Settings</h3>
            <div className="mb-5">
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleConfirmationModal}
              >
                <p className="fs-16 m-0">Pause Account</p>
                <ChevronRightIcon />
              </div>
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleChangePasswordModal}
              >
                <p className="fs-16 m-0">Change Password</p>
                <ChevronRightIcon />
              </div>
            </div>
            <div className="mt-4">
              <Button fullWidth id="btn-primary-no-shadow" onClick={handleAccountSettingsModal}>Save</Button>
            </div>
          </div>
        </Box>
      </Modal>
        <ConfirmationModal
          handleConfirmationModal={handleConfirmationModal}
          modalOpen={confirmationModal}
        />
        <ChangePasswordModal
          handleChangePasswordModal={handleChangePasswordModal}
          modalOpen={changePasswordModal}
        />
    </div>
  )
}

export default AccountSettingsModal
